import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const rebateCsvPreprocessStep = defineStepConfig({
  type: "rebate_csv_preprocess",
  name: "Rebate CSV Preprocess",
  description: "Clean and prepare the raw CSV data for transformation",
  category: "Transformation",
  libraryModule: "Rebates",

  inputSchema: z.object({
    rebateSessionId: z.string().uuid(),
  }),

  outputSchema: z.object({
    rebateSessionId: z.string().uuid(),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "10 minutes",
  },
});
